import React, { useContext } from 'react';


const Deals = () => {
    
    return (
        <div>
            
            <h1> Make Deals </h1>
        </div>
    );
};

export default Deals;